const checkShouldRefresh = async () => {
	// scrollY isn't available immediately
	await new Promise((resolve) => setTimeout(resolve, 50));
	return window.scrollY < 0.5 * window.innerHeight;
};
export default checkShouldRefresh;
